import React from 'react';
import { shoppingTrolley } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Grocery store',
  synonyms: 'supermarket shop store',
  group: 'standardMarker',
  typeUrl: 'grocery-store',
  icon: {
    baseShape: shoppingTrolley,
    iconColor: '#fff',
    markerColor: '#906BD9',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'general-services',
    order: 5,
  },
  standardMarkerOptions: {
    markerType: 'groceryStoreMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Grocery store',
      itemTitleFunction: (item) => (item && item.title) || 'Grocery store',
    },
    creationOptions: {
      menuText: 'Grocery store',
      newTitle: 'Grocery store',
      titlePlaceholder: 'Name of grocery store',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker indicates a grocery store location.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Grocery store',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
